import './NewLogin.css';
import React, { useContext, useState } from "react"
import Swal from 'sweetalert2'
import { Unauthorized } from "../helpers/Unauthorized"
import axios from "axios"
import { authContext } from '../Context/AuthContext';
import { Button, Container } from 'react-bootstrap';

const urlApiLogin = process.env.REACT_APP_API_LOGIN

export const ChangePassword = () => {

    const { token, desloguearse } = useContext(authContext)
    const [oldPass, setOldPass] = useState({})
    const [newPass, setNewPass] = useState({})
    const [newPass2, setNewPass2] = useState({})
    const [showPassword, setShowPassword] = useState(false);


    const inputChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        setOldPass(values => ({ ...values, [name]: value }))
    }

    const inputChange2 = (e) => {
        let name = e.target.name
        let value = e.target.value
        setNewPass(values => ({ ...values, [name]: value }))
    }

    const inputChange3 = (e) => {
        let name = e.target.name
        let value = e.target.value
        setNewPass2(values => ({ ...values, [name]: value }))
    }

    const changingPassword = (e) => {
        e.preventDefault()
        console.log('👉 ppp ▶', oldPass, newPass, newPass2);

        if (newPass.newPassword !== newPass2.newPassword2) {
            Swal.fire({
                title: 'Contraseña inválida',
                text: 'La nueva contraseña no coincide ',
                icon: 'warning',
                confirmButtonText: 'Entendido'
            })
            return false;
        }

        axios.post(`${urlApiLogin}/change-password`, {
            ActualPass: oldPass.oldPassword,
            NuevaPass: newPass.newPassword
        },
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
            .then(res => {
                console.log(res);
                Swal.fire({
                    title: 'Contrseña modificada correctamente',
                    text: 'Ha cambiado con éxito su contraseña. Inicie sesión nuevamente.',
                    icon: 'success',
                    confirmButtonText: 'Entendido'
                }).then(function () {
                    desloguearse();
                });
            })
            .catch(
                err => {
                    console.log('res!!!', err.response);
                    if (err.response.status === 400) {
                        Swal.fire({
                            title: 'Contraseña inválida',
                            text: err.response.data.message,
                            icon: 'warning',
                            confirmButtonText: 'Entendido'
                        })
                    }
                    else {
                        Swal.fire({
                            title: 'Error interno',
                            text: err.response.data.message,
                            icon: 'warning',
                            confirmButtonText: 'Entendido'
                        })
                    }
                }
            )
        setOldPass({})
        setNewPass({})
        setNewPass2({})
    }

    if (token === undefined || token === false) {
        return (
            <Unauthorized />
        )
    }

    // Muestro password 
    const handleShowPassword = () => {
        !showPassword ? setShowPassword(true) : setShowPassword(false);
    }

    return (
        <Container>
            <div style={{
                background: 'rgba(255,255,255,0.7)',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                borderRadius: '1.2rem',
                boxShadow: '0 2px 16px rgba(30,60,120,0.09)',
                padding: '2.2rem 2rem',
                maxWidth: '600px',
                margin: '2.5rem auto',
                border: '1px solid #e3e6ee',
            }}>
                <h2 style={{
                    textAlign: 'center',
                    fontSize: '2.1rem',
                    fontWeight: 700,
                    color: '#1a2340',
                    marginBottom: '2rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.7rem',
                }}>
                    Cambie su contraseña <span role="img" aria-label="llave">🔑</span>
                </h2>
                <form onSubmit={changingPassword}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={!showPassword ? "password" : "text"}
                                name="oldPassword"
                                value={oldPass.oldPassword || ""}
                                onChange={inputChange}
                                placeholder="Contraseña actual"
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.7rem 2.5rem 0.7rem 1rem',
                                    borderRadius: '0.7rem',
                                    border: '1px solid #e3e6ee',
                                    fontSize: '1.08rem',
                                    background: 'rgba(255,255,255,0.95)',
                                }}
                            />
                            <button type="button" onClick={handleShowPassword} style={{
                                position: 'absolute',
                                right: '0.7rem',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                fontSize: '1.2rem',
                                color: '#4a5a7a',
                                cursor: 'pointer',
                            }}>
                                {!showPassword ? <i className="fa-solid fa-eye"></i> : <i className="fa-solid fa-eye-slash"></i>}
                            </button>
                        </div>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={!showPassword ? "password" : "text"}
                                name="newPassword"
                                value={newPass.newPassword || ""}
                                onChange={inputChange2}
                                placeholder="Nueva contraseña"
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.7rem 2.5rem 0.7rem 1rem',
                                    borderRadius: '0.7rem',
                                    border: '1px solid #e3e6ee',
                                    fontSize: '1.08rem',
                                    background: 'rgba(255,255,255,0.95)',
                                }}
                            />
                            <button type="button" onClick={handleShowPassword} style={{
                                position: 'absolute',
                                right: '0.7rem',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                fontSize: '1.2rem',
                                color: '#4a5a7a',
                                cursor: 'pointer',
                            }}>
                                {!showPassword ? <i className="fa-solid fa-eye"></i> : <i className="fa-solid fa-eye-slash"></i>}
                            </button>
                        </div>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={!showPassword ? "password" : "text"}
                                name="newPassword2"
                                value={newPass2.newPassword2 || ""}
                                onChange={inputChange3}
                                placeholder="Ingrese nuevamente la nueva contraseña"
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.7rem 2.5rem 0.7rem 1rem',
                                    borderRadius: '0.7rem',
                                    border: '1px solid #e3e6ee',
                                    fontSize: '1.08rem',
                                    background: 'rgba(255,255,255,0.95)',
                                }}
                            />
                            <button type="button" onClick={handleShowPassword} style={{
                                position: 'absolute',
                                right: '0.7rem',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                fontSize: '1.2rem',
                                color: '#4a5a7a',
                                cursor: 'pointer',
                            }}>
                                {!showPassword ? <i className="fa-solid fa-eye"></i> : <i className="fa-solid fa-eye-slash"></i>}
                            </button>
                        </div>
                        <Button
                            type="submit"
                            variant="success"
                            style={{ width: '100%', fontWeight: 600, fontSize: '1.08rem', borderRadius: '0.7rem', padding: '0.7rem 0' }}
                        >
                            Cambiar contraseña
                        </Button>
                    </div>
                </form>
            </div>
        </Container>
    )
}